import React from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

const Table = ({ columns, data, defaultSortBy }) => {
  const table = useMaterialReactTable({
    columns,
    data,
    initialState: {
      density: "compact",
      sorting: defaultSortBy ?? [],
      pagination: { pageSize: 15, pageIndex: 0 },
    },
    state: {
      columnPinning: {
        left: ["acft"],
      },
    },
    enableStickyHeader: true,
    enableDensityToggle: false,
    enableColumnPinning: true,
  });

  return <MaterialReactTable table={table} />;
};

export default Table;
